// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1POYn","title":"Info_title__19oED","links":"Info_links__3x5Fj","link":"Info_link__2pAdj","logo":"Info_logo__3y_Lt"};